import React, { useState } from 'react';
import { ThumbsDownIcon, ThumbsUpIcon } from 'lucide-react';
import type { Author } from '../../types/article';
export function ArticleFeedback() {
  const [vote, setVote] = useState<'up' | 'down' | null>(null);
  const btn = (active: boolean) => `flex h-11 items-center gap-2 rounded-[7px] border px-4 text-[15px] font-medium transition-colors duration-150 ease-out ${active ? 'border-ink bg-ink text-white' : 'border-ink/15 text-ink hover:border-ink/35'}`;
  return <div className="flex flex-col gap-4 border-y border-canvas-line py-6 sm:flex-row sm:items-center sm:justify-between" data-id="element-98" data-mp="3p3jr38zx1ajp">
      <p className="text-[16px] font-semibold text-ink" id="feedback-label" data-id="element-99" data-mp="3u4hbls8eegod">
        {vote ? 'Thanks for your feedback.' : 'Was this helpful?'}
      </p>
      <div className="flex gap-2" role="group" aria-labelledby="feedback-label" data-id="element-100" data-mp="1zp500i1fdbl1">
        <button type="button" aria-pressed={vote === 'up'} onClick={() => setVote('up')} className={btn(vote === 'up')} data-id="element-101" data-mp="1zrhozf5lom7l">
          <ThumbsUpIcon className="h-4 w-4" aria-hidden="true" data-id="element-102" data-mp="2y2x55z4euwt5" />
          Yes
        </button>
        <button type="button" aria-pressed={vote === 'down'} onClick={() => setVote('down')} className={btn(vote === 'down')} data-id="element-103" data-mp="2tcgo851dst21">
          <ThumbsDownIcon className="h-4 w-4" aria-hidden="true" data-id="element-104" data-mp="2oclwy0dp21gg" />
          No
        </button>
      </div>
    </div>;
}
export function AuthorBio({
  author
}: {
  author: Author;
}) {
  return <div className="flex gap-4 rounded-[14px] bg-canvas-warm p-6" data-id="element-105" data-mp="3h2b28pxfsnnv">
      <img src={author.photo} alt="" className="h-16 w-16 shrink-0 rounded-full object-cover" data-id="element-106" data-mp="3c2yg67ee3kmc" />
      <div data-id="element-107" data-mp="3c154uesu0c80">
        <p className="text-[13px] text-ink-muted" data-id="element-108" data-mp="3814i86vkwupv">Written by</p>
        <p className="text-[17px] font-semibold text-ink" data-id="element-109" data-mp="37zjqsq4k9rw8">{author.name}</p>
        <p className="text-[14px] text-ink-muted" data-id="element-110" data-mp="331i6y2zb9ojp">{author.role}</p>
        <p className="mt-3 text-[15px] leading-[1.6] text-ink-soft" data-id="element-111" data-mp="1wmqzfgfon5gp">{author.bio}</p>
      </div>
    </div>;
}
export function ArticleTags({
  tags
}: {
  tags: string[];
}) {
  return <div data-id="element-112" data-mp="1t4aa7bhl6w2p">
      <p className="sr-only" data-id="element-113" data-mp="1t4jsecwe3yxu">Tags</p>
      <ul className="flex flex-wrap gap-2" data-id="element-114" data-mp="1t5lct7zapxs8">
        {tags.map(tag => <li key={tag} className="rounded-full border border-canvas-line px-3 py-1.5 text-[13px] font-medium text-ink-soft" data-id="element-115" data-mp="1y3mw9u0mvz48">
            {tag}
          </li>)}
      </ul>
    </div>;
}